export const generateQuickStartStyles = () => ({
    wrapper: {
        marginTop: '56px',
        marginBottom: '96px',
    },
    title: {
        marginBottom: '10px',
        fontSize: '16px',
        letterSpacing: 0,
        fontWeight: 500,
    },
    cards: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gridTemplateRows: 'repeat(1, 1fr)',
        gridColumnGap: '64px',
        gridRowGap: '48px',
        paddingTop: '24px',
    },
});
